'use strict';

var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');
Object.defineProperty(exports, '__esModule', {
	value: true
});
exports.getQueryClient = void 0;
var _regenerator = _interopRequireDefault(require('@babel/runtime/regenerator'));
var _asyncToGenerator2 = _interopRequireDefault(require('@babel/runtime/helpers/asyncToGenerator'));
var _proto = require('@sei-js/proto');
var getQueryClient = (exports.getQueryClient = /*#__PURE__*/ (function () {
	var _ref = (0, _asyncToGenerator2['default'])(
		/*#__PURE__*/ _regenerator['default'].mark(function _callee(restEndpoint) {
			return _regenerator['default'].wrap(function _callee$(_context) {
				while (1)
					switch ((_context.prev = _context.next)) {
						case 0:
							_context.next = 2;
							return _proto.seiprotocol.ClientFactory.createLCDClient({
								restEndpoint: restEndpoint
							});
						case 2:
							return _context.abrupt('return', _context.sent);
						case 3:
						case 'end':
							return _context.stop();
					}
			}, _callee);
		})
	);
	return function getQueryClient(_x) {
		return _ref.apply(this, arguments);
	};
})());
//# sourceMappingURL=queryClient.js.map
